import { createAction } from "@reduxjs/toolkit";

// Resets every slice to its initial state (see redux/index.js) and reaches every open tab.
export const loggedOut = createAction("app/loggedOut");
